// extracted by mini-css-extract-plugin
export default {"todolist-body":"styles_todolist-body__45LN7"};